import { useCallback } from "react";
import { useArchiveDestination } from "../services/api/KeynomeAPIHooks";
import { useNavigate } from 'react-router-dom';
// import { useQueryClient } from "@tanstack/react-query";
import { datadogRum } from '@datadog/browser-rum';
import { useOutletContext } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";

import { useMoveDatasetToProject } from "../services/api/KeynomeAPIMutations";

function ArchiveDatasetDialog(props) {
    const {
        activeProject,
        activeRun,
        setVisibleRuns,
        archiveDialogOpen,
        setArchiveDialogOpen,
        setReloadRuns,
        handleClose,
    } = props;

    const navigate = useNavigate();
    // const queryClient = useQueryClient();
    const { setUserErrorMessage } = useOutletContext();

    const { archiveProject } = useArchiveDestination(activeProject.attributes.organization_id);

    const { mutate: moveDatasetToProject, isLoading: isArchiving } = useMoveDatasetToProject(); 

    const handleArchiveConfirm = useCallback(() => {
        moveDatasetToProject(
            { datasetId: activeRun.id, destProjectId: archiveProject.id },
            {
                onSuccess: () => {
                    handleClose()
                    setVisibleRuns?.((visibleRuns) => visibleRuns.filter(run => run.id !== activeRun.id));
                    setArchiveDialogOpen(false);
                    setReloadRuns()

                    const activeProjectURL = new URL(activeProject.attributes.keynome_web_url);
                    navigate(activeProjectURL.pathname);
                },
                onError: (error) => {
                    setUserErrorMessage('Failed to archive dataset. Please wait a few minutes and try again. Contact pathosight-support@cepheid.com if you require assistance.');
                    datadogRum.addError(error);
                }
            }
        )
    }, [activeProject, activeRun, archiveProject, moveDatasetToProject, setUserErrorMessage, navigate, setReloadRuns, setVisibleRuns, handleClose, setArchiveDialogOpen]);

    return <Dialog
        open={archiveDialogOpen}
        onClose={() => setArchiveDialogOpen(false)}
    >
        <DialogTitle>Archive Dataset</DialogTitle>
        <DialogContent>
        <DialogContentText>
            { !!archiveProject
                ? "Are you sure you want to archive this dataset? After archiving, you will no longer be able to see any samples or results associated with this dataset."
                : "Unable to archive projects in this organization. Contact pathosight-support@cepheid.com if you require assistance."
            }
        </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button onClick={() => setArchiveDialogOpen(false)} disabled={isArchiving}>Cancel</Button>
        {
            !!archiveProject ?
            <Button 
                onClick={handleArchiveConfirm}
                color="primary"
                variant="contained"
                autoFocus
                disabled={isArchiving}
                aria-label="confirm-archive"
            >
                {isArchiving ? 'Archiving...' : 'Yes, Archive'}
            </Button>
            : <></>
    }
        </DialogActions>
    </Dialog>
}

export default ArchiveDatasetDialog;
